import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Percent } from "lucide-react";

const ROLE = { master: "master", dealer: "dealer diretto" };

const AggioRow = ({ it, v, onChange }) => {
  const custom = v !== null && v !== undefined;
  return <div className="grid grid-cols-[1fr_auto_6rem] items-center gap-3 py-2" data-testid={`aggio-row-${it.key}`}>
    <div><p className="text-sm font-medium">{it.name}</p><p className="text-xs text-muted-foreground" data-testid={`aggio-default-${it.key}`}>{custom ? "Personalizzato" : `Eredita ${it.default}% dalle impostazioni operatore`}</p></div>
    <label className="flex items-center gap-2 text-xs text-muted-foreground">Personalizza<Switch checked={custom} onCheckedChange={(on) => onChange(on ? String(it.default) : null)} data-testid={`aggio-custom-${it.key}`} /></label>
    <Input type="number" min="0" max="100" step="0.1" disabled={!custom} value={custom ? v : it.default} onChange={(e) => onChange(e.target.value)} aria-label={`Aggio ${it.name} %`} data-testid={`aggio-input-${it.key}`} />
  </div>;
};

export const DealerOperatorAggio = ({ dealer }) => {
  const [open, setOpen] = useState(false);
  const [view, setView] = useState(null);
  const [vals, setVals] = useState({});
  const [busy, setBusy] = useState(false);
  const fill = (d) => { setView(d); setVals(Object.fromEntries(d.items.map((i) => [i.key, i.custom ?? null]))); };
  useEffect(() => { if (open) { api.get(`/admin/users/${dealer.id}/operator-aggio`).then((r) => fill(r.data)).catch(() => toast.error("Aggio non disponibile")); } }, [open, dealer.id]);
  const bad = Object.values(vals).some((v) => v !== null && (v === "" || Number(v) < 0 || Number(v) > 100));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/users/${dealer.id}/operator-aggio`, { values: Object.fromEntries(Object.entries(vals).map(([k, v]) => [k, v === null ? null : Number(v)])) });
      fill(data); toast.success("Aggio salvato"); setOpen(false);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Salvataggio non riuscito"); }
    finally { setBusy(false); }
  };
  return <>
    <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={`dealer-aggio-open-${dealer.id}`}><Percent className="w-4 h-4" /> Aggio operatori</Button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="dealer-aggio-dialog">
        <DialogHeader><DialogTitle>Aggio operatori · {dealer.company_name || dealer.name}</DialogTitle>
          {view?.role !== "sub" && <DialogDescription>Percentuale tolta da tutto quello che paga dal Plafond per ogni operatore. Se non personalizzi, eredita il valore impostato per i {ROLE[view?.role] || "dealer"} in Operatori, offerte e prezzi.</DialogDescription>}</DialogHeader>
        {!view ? <p className="text-sm text-muted-foreground">Caricamento…</p> : view.role === "sub" ? <p className="text-sm" data-testid="dealer-aggio-sub">Questo dealer sta sotto un master: l'aggio glielo dà il suo master quando gli passa il Plafond.</p> : <>
          <div className="divide-y divide-border">{view.items.map((it) => <AggioRow key={it.key} it={it} v={vals[it.key]} onChange={(v) => setVals((s) => ({ ...s, [it.key]: v }))} />)}</div>
          {bad && <p className="text-xs text-destructive" data-testid="dealer-aggio-error">Inserisci valori da 0 a 100.</p>}
          <Button disabled={busy || bad} onClick={save} data-testid="dealer-aggio-save">{busy ? "Salvataggio…" : "Salva aggio"}</Button>
        </>}
      </DialogContent>
    </Dialog>
  </>;
};
